export default function useEnvironment() {
  const isDevelopment = process.env.NODE_ENV === 'development';
  return {
    isDevelopment,
  };
}
